import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'whitespaceRemoving'
})
export class WhitespaceRemovingPipe implements PipeTransform {

  transform(value: string): any {
    return value.replace(/[\s]/g, '');
  }

}
